"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityConnectionsBanner = exports.EntityConnectionsBannerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_lang_1 = require("../../hooks/use-lang");
var sprintf_js_1 = require("sprintf-js");
var entity_banner_1 = require("./entity-banner");
var lodash_1 = require("lodash");
exports.EntityConnectionsBannerDefaultProps = {};
// -------- Styles -------->
var BannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n    padding-bottom: 0;\n    border-bottom: 1px solid ", ";\n  "], ["\n    padding: ", ";\n    padding-bottom: 0;\n    border-bottom: 1px solid ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.COLOR('line-subtle')),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Banner: (0, styled_components_1.default)(entity_banner_1.EntityBanner).attrs({
    size: 'small'
  })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles)
};
var EntityConnectionsBanner = function (props) {
  var className = props.className,
    entity = props.entity,
    controls = props.controls;
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var t = (0, use_lang_1.useLang)();
  var title = props.title || (definition ? (0, sprintf_js_1.sprintf)(t('%s Connections'), definition.label) : t('Please wait...'));
  var tweakedEntity = __assign(__assign({}, entity), {
    name: (0, lodash_1.truncate)(entity.name, {
      length: 90
    })
  });
  return react_1.default.createElement(My.Banner, {
    showLoading: false,
    title: title,
    alwaysShowIcon: false,
    entity: tweakedEntity,
    className: className,
    controls: controls
  });
};
exports.EntityConnectionsBanner = EntityConnectionsBanner;
exports.EntityConnectionsBanner.defaultProps = exports.EntityConnectionsBannerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;